import { Box, FormControl, FormControlLabel, Switch, Typography } from "@mui/material"
import BaseSelector from "../base-selector"
import { BaseInstrumentWithName } from "../../types"
import { BaseInstrument } from "../base-selector/types"

import "./style.scss"

interface BenchmarkProps {
  account: string
  modelId?: string
  baseInstrument: BaseInstrument | null
  handleInstrumentSelected: (instrument: BaseInstrumentWithName | null) => void
  isBaseOverridden: boolean
  onBaseOverrideToggle: (checked: boolean) => void
}

export default function Benchmark({
  account,
  modelId,
  baseInstrument,
  handleInstrumentSelected,
  isBaseOverridden,
  onBaseOverrideToggle,
}: BenchmarkProps) {
  return (
    <Box className="components_benchmark">
      <Typography color="inherit" noWrap className="benchmark-label">
        Benchmark
      </Typography>
      <Typography color="secondary" variant="caption">
        Define your optimization&apos;s benchmark.
      </Typography>
      <Box className="benchmark-override">
        <FormControlLabel
          control={
            <Switch
              size="small"
              checked={isBaseOverridden}
              onChange={(e) => onBaseOverrideToggle(e.target.checked)}
            />
          }
          label="Override Benchmark"
        />
      </Box>
      <FormControl component="fieldset" className="benchmark-selector">
        <BaseSelector
          account={account}
          modelId={modelId}
          baseInstrument={baseInstrument}
          handleInstrumentSelected={handleInstrumentSelected}
          label="Benchmark"
          allowNone
          disabled={!isBaseOverridden}
        />
      </FormControl>
    </Box>
  )
}
